/* ============================================================
   azado Theme — Verhalten
   Portiert aus dem Prototyp (js/main.js). Unterschied zum Prototyp:
   - Header/Footer werden NICHT mehr per JS injiziert (kommen aus Liquid)
   - Warenkorb läuft über die echte Shopify Cart API statt sessionStorage
   ============================================================ */

(function () {
  "use strict";

  var ROUTES = window.azadoRoutes || {
    cartAdd: "/cart/add.js", cartChange: "/cart/change.js",
    cart: "/cart.js", cartPage: "/cart", search: "/search"
  };

  /* ---------- Helfer ---------- */

  function money(cents) {
    try {
      return new Intl.NumberFormat("de-CH", {
        style: "currency", currency: window.Shopify && window.Shopify.currency
          ? window.Shopify.currency.active : "CHF",
        minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(cents / 100).replace(/’/g, "'"); /* gleiches Apostroph wie Shopifys Preisformat */
    } catch (e) {
      return "CHF " + (cents / 100).toFixed(2);
    }
  }

  var toastTimer;
  function toast(html) {
    var t = document.getElementById("toast");
    if (!t) return;
    t.innerHTML = html;
    t.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("is-visible"); }, 3200);
  }
  window.azadoToast = toast;

  /* Hintergrund nicht mitscrollen lassen, solange Warenkorb, Suche oder Newsletter offen sind
     (auf dem iPhone scrollte die Seite sonst hinter dem Overlay weiter). Eigene Klasse statt
     az-locked, damit sich das nicht mit dem Beratungs-Dialog (azado-v2.js) in die Quere kommt. */
  function syncScrollLock() {
    var open = document.querySelector(".cart-drawer.is-open, .search-overlay.is-open, #newsletter-popup.is-open");
    document.documentElement.classList.toggle("az-noscroll", !!open);
  }

  /* ---------- Hero-Video Outro abschneiden ---------- */

  /* V2: der Theme-Spot ist bereits ohne Outro geschnitten. Nur wenn ein eigenes Video mit
     data-outro-seconds hinterlegt ist, wird dessen Ende weiterhin abgeschnitten. */
  function initHeroVideoToggle() {
    var video = document.getElementById("hero-video-el");
    if (!video) return;
    var HERO_VIDEO_OUTRO_SECONDS = parseFloat(video.getAttribute("data-outro-seconds") || "0");
    if (!HERO_VIDEO_OUTRO_SECONDS) return;
    video.addEventListener("timeupdate", function () {
      if (video.duration && video.currentTime >= video.duration - HERO_VIDEO_OUTRO_SECONDS) {
        video.currentTime = 0;
      }
    });
  }

  /* ---------- Header: Scroll-Zustand ---------- */

  function initHeaderScroll() {
    var header = document.querySelector(".header");
    if (!header) return;
    if (document.body.getAttribute("data-header") === "light") header.classList.add("on-light");
    function onScroll() { header.classList.toggle("is-scrolled", window.scrollY > 40); }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Burger-Menü ---------- */

  function initNavMore() {
    /* Das Auf-/Zuklappen selbst läuft rein über CSS (Checkbox + :checked, siehe azado-core.css) —
       funktioniert also auch, falls dieses Skript aus irgendeinem Grund nicht lädt/ausführt.
       JS kommt hier nur als Komfort-Layer dazu: Klick ausserhalb oder Escape schliesst zusätzlich,
       und aria-expanded wird für Screenreader synchron gehalten. Delegiert auf document statt
       eine Referenz beim Start zu binden, damit es auch nach einem Neu-Rendern des Headers robust bleibt. */
    document.addEventListener("change", function (e) {
      if (e.target && e.target.id === "nav-more-toggle") {
        var btn = document.getElementById("more-open");
        if (btn) btn.setAttribute("aria-expanded", e.target.checked ? "true" : "false");
      }
    });
    document.addEventListener("click", function (e) {
      var toggle = document.getElementById("nav-more-toggle");
      var wrapper = document.querySelector(".nav-more");
      if (!toggle || !wrapper || !toggle.checked) return;
      /* Ein Klick auf das <label> löst intern zusätzlich einen (bubblenden) Klick auf die
         Checkbox selbst aus (Browser-Standardverhalten). Die Checkbox liegt ausserhalb von
         .nav-more-panel und ist kein Nachfahre des <label>, daher muss der GESAMTE Wrapper
         (.nav-more: Checkbox + Label + Panel) geprüft werden — nicht nur das Panel. */
      if (!wrapper.contains(e.target)) {
        toggle.checked = false;
        toggle.dispatchEvent(new Event("change"));
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var toggle = document.getElementById("nav-more-toggle");
      if (toggle && toggle.checked) {
        toggle.checked = false;
        toggle.dispatchEvent(new Event("change"));
      }
    });
  }

  /* ---------- Disclosure-Dropdowns (Sprachauswahl, Sortieren) ---------- */

  /* Gemeinsame Öffnen/Schliessen-Logik für Button+Liste-Dropdowns: Klick ausserhalb und
     Escape schliessen, aria-expanded bleibt synchron. Wiederverwendet von initLangSelect()
     und initSortSelect(), damit beide identisch funktionieren statt zwei Kopien zu pflegen. */
  function initDisclosure(wrapperId, toggleSelector, listSelector) {
    var wrapper = document.getElementById(wrapperId);
    if (!wrapper) return;
    var btn = wrapper.querySelector(toggleSelector);
    var list = wrapper.querySelector(listSelector);
    if (!btn || !list) return;

    function close() {
      list.hidden = true;
      btn.setAttribute("aria-expanded", "false");
    }
    function open() {
      list.hidden = false;
      btn.setAttribute("aria-expanded", "true");
    }

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      if (list.hidden) open(); else close();
    });
    document.addEventListener("click", function (e) {
      if (!list.hidden && !wrapper.contains(e.target)) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !list.hidden) close();
    });
  }

  function initLangSelect() {
    initDisclosure("lang-select", ".header-lang__toggle", ".header-lang__list");
  }

  function initSortSelect() {
    initDisclosure("sort-select", ".sort-select__toggle", ".sort-select__list");
  }

  function initFilterPills() {
    initDisclosure("filter-size", ".filter-pill__toggle", ".filter-pill__list");
    initDisclosure("filter-kurbel", ".filter-pill__toggle", ".filter-pill__list");
  }

  /* ---------- Scroll-Reveals ---------- */

  function initReveals() {
    var els = document.querySelectorAll("[data-reveal]");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("in-view"); });
      return;
    }
    var groups = new Map();
    els.forEach(function (el) {
      var parent = el.parentElement;
      if (!groups.has(parent)) groups.set(parent, 0);
      var idx = groups.get(parent);
      el.style.setProperty("--d", Math.min(idx * 0.09, 0.5) + "s");
      groups.set(parent, idx + 1);
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in-view"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax-Drift (nutzt CSS translate, damit hover:scale erhalten bleibt) ---------- */

  function initParallax() {
    var els = document.querySelectorAll("[data-parallax]");
    if (!els.length || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var ticking = false;
    var vh = window.innerHeight, lastW = window.innerWidth;
    function update() {
      ticking = false;
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var progress = (r.top + r.height / 2 - vh / 2) / vh;
        var f = parseFloat(el.getAttribute("data-parallax")) || 0.12;
        el.style.translate = "0 " + (progress * f * 100).toFixed(2) + "px";
      });
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    /* Höhe nur bei echter Grössenänderung neu messen: auf dem Handy feuert "resize" auch,
       wenn beim Scrollen die Adressleiste ein-/ausfährt — sonst springen die Bilder. */
    window.addEventListener("resize", function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      vh = window.innerHeight;
      update();
    });
    update();
  }

  /* ---------- Überlappender Scroll-Effekt ---------- */

  function initOverlapScroll() {
    var sections = document.querySelectorAll(".overlap");
    if (!sections.length || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var ticking = false;
    var vh = window.innerHeight, lastW = window.innerWidth;
    function update() {
      ticking = false;
      sections.forEach(function (sec) {
        var r = sec.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var total = r.height - vh;
        var progress = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
        sec.querySelectorAll("[data-depth]").forEach(function (fig) {
          var depth = parseFloat(fig.getAttribute("data-depth")) || 0;
          fig.style.transform = "translate3d(0," + ((progress - 0.5) * depth * vh).toFixed(1) + "px,0)";
        });
      });
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    /* Höhe nur bei echter Grössenänderung neu messen: auf dem Handy feuert "resize" auch,
       wenn beim Scrollen die Adressleiste ein-/ausfährt — sonst springen die Bilder. */
    window.addEventListener("resize", function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      vh = window.innerHeight;
      update();
    });
    update();
  }

  /* ---------- Warenkorb (echte Shopify Cart API) ---------- */

  function initCart() {
    var drawer = document.getElementById("cart-drawer");
    var scrim = document.getElementById("cart-scrim");
    var openBtn = document.getElementById("cart-open");
    if (!drawer || !scrim) return;

    function open() {
      drawer.classList.add("is-open"); scrim.classList.add("is-open"); syncScrollLock();
      document.dispatchEvent(new CustomEvent("azado:cart-open"));
    }
    function close() { drawer.classList.remove("is-open"); scrim.classList.remove("is-open"); drawer.style.transform = ""; syncScrollLock(); }
    function isSmall() { return window.matchMedia && window.matchMedia("(max-width: 760px)").matches; }

    /* V2: Nach dem Hinzufügen auf dem Handy den Warenkorb NICHT aufklappen, sondern oben kurz eine
       Bestätigung einblenden (antippen öffnet den Warenkorb). Desktop: Drawer wie bisher. */
    var addedBar = null, addedTimer = null;
    function showAdded(title) {
      var pill = document.getElementById("cart-open");
      if (pill) { pill.classList.remove("bump"); void pill.offsetWidth; pill.classList.add("bump"); }
      if (!addedBar) {
        addedBar = document.createElement("button");
        addedBar.type = "button";
        addedBar.className = "az-added";
        addedBar.addEventListener("click", function () { addedBar.classList.remove("is-on"); open(); });
        document.body.appendChild(addedBar);
      }
      var label = drawer.getAttribute("data-added") || "liegt im Warenkorb";
      var view = drawer.getAttribute("data-view") || "Ansehen";
      addedBar.innerHTML = '<span class="az-added__ic" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10h18l-1.6 9.1a1.6 1.6 0 0 1-1.6 1.4H6.2a1.6 1.6 0 0 1-1.6-1.4L3 10z"/><path d="M7.5 10L11 4M16.5 10L13 4"/></svg></span><span class="az-added__txt"></span><span class="az-added__cta">' + view + ' &rarr;</span>';
      addedBar.querySelector(".az-added__txt").textContent = (title ? title + " " : "") + label;
      addedBar.classList.remove("is-on"); void addedBar.offsetWidth; addedBar.classList.add("is-on");
      clearTimeout(addedTimer);
      addedTimer = setTimeout(function () { addedBar.classList.remove("is-on"); }, 3800);
    }
    window.azadoShowAdded = showAdded;

    /* Okt. 2026: "Optimistisches" Hinzufügen. Rückmeldung kommt sofort beim Klick (Bestätigung,
       Zähler, Häkchen im Button), der Shop bestätigt im Hintergrund. Schlägt das fehl, wird der
       Zähler über refresh() wieder auf den echten Stand gesetzt und eine Meldung gezeigt. */
    var optimistic = null;
    function setCount(delta) {
      var c = document.getElementById("cart-count"); if (!c) return;
      var n = Math.max(0, (parseInt(c.textContent, 10) || 0) + delta);
      c.textContent = n; c.classList.toggle("has-items", n > 0);
    }
    function flashButton(btn) {
      return; /* Okt. 2026: kein Haken im Button, die Bestätigung oben reicht */
      if (!btn) return;
      btn.classList.remove("az-btn-added"); void btn.offsetWidth; btn.classList.add("az-btn-added");
      setTimeout(function () { btn.classList.remove("az-btn-added"); }, 1600);
    }
    function instantAdd(title, qty, btn) {
      setCount(qty);
      flashButton(btn);
      drawer.classList.add("is-syncing");
      showAdded(title);
      if (optimistic && optimistic.timer) clearTimeout(optimistic.timer);
      optimistic = { qty: qty, at: Date.now() };
      /* Sicherheitsnetz: kommt keine Bestätigung, Stand neu laden (korrigiert den Zähler) */
      optimistic.timer = setTimeout(function () { optimistic = null; refresh(); }, 8000);
    }
    function instantFail(msg) {
      if (optimistic && optimistic.timer) clearTimeout(optimistic.timer);
      optimistic = null;
      if (addedBar) addedBar.classList.remove("is-on");
      toast(msg || "Konnte nicht hinzugefügt werden.");
      refresh();
    }
    window.azadoInstantFail = instantFail;

    /* Produktformular (Dawn + Set-Builder): Rückmeldung schon beim Absenden. Capture-Phase und
       vor azado-buybox.js registriert, läuft also immer zuerst. */
    document.addEventListener("submit", function (e) {
      var f = e.target;
      if (!f || !f.action || f.action.indexOf("/cart/add") === -1) return;
      var btn = f.querySelector('[type="submit"], [name="add"]');
      if (btn && (btn.disabled || btn.getAttribute("aria-disabled") === "true")) return;
      var qtyInput = document.querySelector('#MainContent input[name="quantity"]') || f.querySelector('input[name="quantity"]');
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      document.querySelectorAll('.az-set input[type="checkbox"]:checked, .az-addons input[type="checkbox"]:checked').forEach(function () { qty += 1; });
      var h = document.querySelector("#MainContent .product__title h1") || document.querySelector("#MainContent .product__title");
      instantAdd(h ? h.textContent.trim() : "", qty, btn);
    }, true);

    /* Handy: Warenkorb mit einer Wischbewegung nach rechts schliessen */
    (function () {
      var x0 = null, y0 = null, dx = 0;
      drawer.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; }, { passive: true });
      drawer.addEventListener("touchmove", function (e) {
        if (x0 === null) return;
        dx = e.touches[0].clientX - x0;
        var dy = Math.abs(e.touches[0].clientY - y0);
        if (dx > 0 && dx > dy) { drawer.style.transition = "none"; drawer.style.transform = "translateX(" + dx + "px)"; }
      }, { passive: true });
      drawer.addEventListener("touchend", function () {
        drawer.style.transition = "";
        if (dx > 90) close(); else drawer.style.transform = "";
        x0 = null; dx = 0;
      });
    })();
    var keepBtn = document.getElementById("cart-keep-shopping");
    if (keepBtn) keepBtn.addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && drawer.classList.contains("is-open")) close(); });

    if (openBtn) openBtn.addEventListener("click", open);
    var closeBtn = document.getElementById("cart-close");
    if (closeBtn) closeBtn.addEventListener("click", close);
    scrim.addEventListener("click", close);

    var SHIP_THRESHOLD = ROUTES.shipThreshold || 15000; /* Rappen — aus settings.free_shipping_threshold im Theme-Editor, siehe theme.liquid */
    function updateShipBar(cart) {
      var msg = document.getElementById("cart-shipbar-msg");
      var fill = document.getElementById("cart-shipbar-fill");
      if (!msg || !fill) return;
      /* Grills und Aussenküchen gehen per Spedition raus, nie per Standardversand — daher nie
         Gratisversand, unabhängig vom Bestellwert, sobald eines davon im Warenkorb liegt.
         Ausnahme: El Chiquito wird als Paket verschickt und zählt daher nicht als Grill hier. */
      var hasFreightItem = cart.items.some(function (it) {
        if (it.handle === "el-chiquito") return false;
        /* product_type ist je Sprache übersetzt (fr "Barbecue", en "Outdoor Kitchens" …) */
        return ["Grill", "Barbecue", "Aussenküchen", "Cuisines d'extérieur", "Cuisines extérieures", "Outdoor Kitchens"].indexOf(it.product_type) !== -1;
      });
      var bar = document.getElementById("cart-shipbar");
      function txt(key, fallback) { return (bar && bar.getAttribute("data-msg-" + key)) || fallback; }
      if (hasFreightItem) {
        msg.textContent = txt("blocked", "Für Grills und Aussenküchen wird die Lieferung mit dir abgesprochen.");
        fill.style.width = "0%";
        return;
      }
      /* El Chiquito geht per Post raus wie normales Zubehör — unabhängig vom sonstigen
         Bestellwert/Schwellenwert immer Gratisversand, nicht erst ab CHF 150. */
      var hasChiquito = cart.items.some(function (it) { return it.handle === "el-chiquito"; });
      if (hasChiquito) {
        msg.textContent = txt("unlocked", "Gratis Versand freigeschaltet!");
        fill.style.width = "100%";
        return;
      }
      var remaining = SHIP_THRESHOLD - cart.total_price;
      var percent = Math.min(100, (cart.total_price / SHIP_THRESHOLD) * 100);
      msg.textContent = remaining <= 0 ? txt("unlocked", "Gratis Versand freigeschaltet!")
        : txt("remaining", "Noch {{ amount }} bis gratis Versand.").replace(/\{\{\s*amount\s*\}\}/, money(remaining));
      fill.style.width = percent + "%";
    }

    function renderCart(cart) {
      drawer.classList.remove("is-syncing");
      var count = document.getElementById("cart-count");
      var total = document.getElementById("cart-total");
      var items = document.getElementById("cart-items");
      if (count) {
        count.textContent = cart.item_count;
        count.classList.toggle("has-items", cart.item_count > 0);
      }
      if (total) total.textContent = money(cart.total_price);
      updateShipBar(cart);
      if (!items) return;
      if (!cart.items.length) {
        var emptyTpl = document.getElementById("az-cart-empty-tpl");
        items.innerHTML = emptyTpl ? emptyTpl.innerHTML : '<div class="cart-empty">Noch ist es hier so leer wie ein Rost vor dem Anfeuern.</div>';
        return;
      }
      /* teuerste Position zuerst (wie Big Green Egg) */
      var sorted = cart.items.slice().sort(function (a, b) { return b.final_line_price - a.final_line_price; });
      items.innerHTML = sorted.map(function (it) {
        var variant = it.variant_title && it.variant_title.indexOf("Default") === -1
          ? '<span class="ci-variant">' + it.variant_title + "</span>" : "";
        var imgSrc = it.image ? it.image + (it.image.indexOf("?") === -1 ? "?" : "&") + "width=160" : "";
        var media = imgSrc ? '<img src="' + imgSrc + '" alt="" width="64" height="64" loading="lazy">' : "";
        return '<div class="cart-item" data-key="' + it.key + '">' +
          '<div class="ci-media">' + media + "</div>" +
          '<div class="ci-body">' +
            '<div class="ci-row"><div class="ci-title">' + it.product_title + variant + '</div>' +
            '<div class="ci-price">' + money(it.final_line_price) + "</div></div>" +
            '<div class="ci-row ci-row--bottom">' +
              '<div class="ci-qty" data-key="' + it.key + '">' +
                '<button type="button" class="ci-qty__btn" data-qty-minus aria-label="Menge verringern">&minus;</button>' +
                '<span class="ci-qty__val">' + it.quantity + '</span>' +
                '<button type="button" class="ci-qty__btn" data-qty-plus aria-label="Menge erhöhen">&plus;</button>' +
              '</div>' +
              '<button type="button" class="ci-remove" data-remove="' + it.key + '">Entfernen</button>' +
            '</div>' +
          '</div></div>';
      }).join("");
    }

    function changeQuantity(key, quantity) {
      return fetch(ROUTES.cartChange, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }

    function refresh() {
      return fetch(ROUTES.cart, { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(renderCart);
    }

    /* Entfernen + Menge (+/-) */
    document.getElementById("cart-items").addEventListener("click", function (e) {
      var remove = e.target.closest("[data-remove]");
      if (remove) {
        changeQuantity(remove.getAttribute("data-remove"), 0);
        return;
      }
      var step = e.target.closest("[data-qty-minus], [data-qty-plus]");
      if (!step) return;
      var wrap = step.closest(".ci-qty");
      var key = wrap.getAttribute("data-key");
      var current = parseInt(wrap.querySelector(".ci-qty__val").textContent, 10) || 1;
      var next = step.hasAttribute("data-qty-plus") ? current + 1 : current - 1;
      changeQuantity(key, next);
    });

    /* Hinzufügen: [data-variant-id] statt Prototyp-[data-add] */
    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-variant-id]");
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var id = b.getAttribute("data-variant-id");
      var qty = parseInt(b.getAttribute("data-quantity"), 10) || 1;
      instantAdd(b.getAttribute("data-title") || "", qty, b);
      fetch(ROUTES.cartAdd, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status !== 200) { instantFail(res.description); return; }
          if (optimistic && optimistic.timer) clearTimeout(optimistic.timer);
          optimistic = null;
          return refresh();
        })
        .catch(function () { instantFail("Da ging etwas schief."); });
    });

    /* Hinzufügen über das native Shopify-Produktformular (product-form.js auf der PDP):
       dort gibt es kein <cart-notification>/<cart-drawer>-Webcomponent, daher feuert
       product-form.js stattdessen "cart:added" statt auf /cart umzuleiten. */
    document.addEventListener("cart:added", function (e) {
      var wasInstant = optimistic && Date.now() - optimistic.at < 10000;
      if (optimistic && optimistic.timer) clearTimeout(optimistic.timer);
      optimistic = null;
      if (!wasInstant) {
        var d = (e && e.detail) || {};
        var it = (d.items && d.items[0]) || d;
        showAdded(it.product_title || "");
      }
      refresh();
    });
    /* Fehler aus dem Dawn-Formular (z. B. nicht genug an Lager) */
    document.addEventListener("cart:error", function () { if (optimistic) instantFail(); }, true);
  }

  /* ---------- Warenkorb-Upsells (zufällig aus einer Kollektion) ---------- */

  function initUpsell() {
    var wrap = document.getElementById("cart-upsell");
    var row = document.getElementById("cart-upsell-row");
    if (!wrap || !row) return;
    var handle = wrap.getAttribute("data-collection");
    var addLabel = wrap.getAttribute("data-add-label") || "Hinzufügen";
    if (!handle) return;

    /* Erst laden, wenn der Warenkorb zum ersten Mal aufgeht — nicht bei jedem Seitenaufruf
       (spart auf dem Handy einen grossen Request pro Seite). */
    var loaded = false;
    document.addEventListener("azado:cart-open", function () {
      if (loaded) return;
      loaded = true;
      loadUpsell();
    });

    function loadUpsell() {
    fetch("/collections/" + handle + "/products.json?limit=50")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.products || []).filter(function (p) {
          return p.variants && p.variants.some(function (v) { return v.available; });
        });
        /* Fisher-Yates: jedes Mal eine andere Auswahl statt immer derselben ersten 6. */
        for (var i = products.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = products[i]; products[i] = products[j]; products[j] = tmp;
        }
        /* Feste Favoriten (data-priority, z. B. Nachfüllgas) immer vorne */
        var prio = (wrap.getAttribute("data-priority") || "").split(",");
        products.sort(function (a, b) {
          var ia = prio.indexOf(a.handle), ib = prio.indexOf(b.handle);
          return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
        });
        var picks = products.slice(0, 6);
        if (!picks.length) return;
        row.innerHTML = picks.map(function (p) {
          var v = p.variants.filter(function (v) { return v.available; })[0];
          var imgUrl = p.images && p.images[0] && p.images[0].src;
          var imgSrc = imgUrl ? imgUrl + (imgUrl.indexOf("?") === -1 ? "?" : "&") + "width=160" : "";
          var media = imgSrc ? '<img src="' + imgSrc + '" alt="" width="56" height="56" loading="lazy">' : "";
          var url = "/products/" + p.handle;
          var title = p.title.replace(/"/g, "&quot;");
          return '<div class="cart-upsell__item">' +
            '<a href="' + url + '" class="cart-upsell__media">' + media + "</a>" +
            '<div class="cart-upsell__info">' +
              '<a href="' + url + '" class="cart-upsell__title">' + p.title + "</a>" +
              '<span class="cart-upsell__price">' + money(Math.round(parseFloat(v.price) * 100)) + "</span>" +
            "</div>" +
            '<button type="button" class="cart-upsell__add" data-variant-id="' + v.id + '" data-title="' + title + '">' +
              '<span class="plus">&plus;</span> ' + addLabel +
            "</button>" +
          "</div>";
        }).join("");
        wrap.hidden = false;
        initUpsellScroll(row);
      })
      .catch(function () {});
    }
  }

  /* Pfeil-Button statt Scrollbalken: nur sichtbar, solange rechts noch was verborgen ist. */
  function initUpsellScroll(row) {
    var next = document.getElementById("cart-upsell-next");
    if (!next) return;
    function update() {
      var hasMore = row.scrollWidth - row.clientWidth - row.scrollLeft > 8;
      next.hidden = !hasMore;
    }
    next.addEventListener("click", function () {
      row.scrollBy({ left: row.clientWidth * 0.8, behavior: "smooth" });
    });
    row.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  /* ---------- Suche (Predictive Search) ---------- */

  function initSearch() {
    var overlay = document.getElementById("search-overlay");
    var input = document.getElementById("search-input");
    var results = document.getElementById("search-results");
    var openBtn = document.getElementById("search-open");
    if (!overlay || !input) return;


    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    }
    function chf(v) {
      var n = parseFloat(v);
      if (!isFinite(n)) return "";
      var w = Math.round(n) === n ? String(Math.round(n)) : n.toFixed(2);
      var sp = w.split(".");
      sp[0] = sp[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
      return "CHF " + sp.join(".");
    }
    function renderSuggest(res, q) {
      var out = "";
      (res.products || []).forEach(function (p) {
        var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf("?") > -1 ? "&" : "?") + 'width=120" alt="" loading="lazy" width="54" height="54">' : "";
        out += '<a class="sr-item" href="' + esc(p.url) + '">' + img +
          '<span class="sr-title">' + esc(p.title) + '</span>' +
          '<span class="price">' + chf(p.price) + "</span></a>";
      });
      var pages = res.pages || [];
      if (pages.length) {
        out += '<p class="sr-group">' + esc(overlay.getAttribute("data-l-pages") || "") + "</p>";
        pages.forEach(function (g) {
          out += '<a class="sr-item" href="' + esc(g.url) + '"><span class="sr-title">' + esc(g.title) + "</span></a>";
        });
      }
      if (!out) return '<div class="cart-empty">' + esc(overlay.getAttribute("data-l-none") || "") + "</div>";
      return out + '<a class="sr-all" href="' + ROUTES.search + "?q=" + encodeURIComponent(q) + '">' +
        esc(overlay.getAttribute("data-l-all") || "") + ' <span class="arrow">&rarr;</span></a>';
    }
    function open() { overlay.classList.add("is-open"); syncScrollLock(); setTimeout(function () { input.focus(); }, 100); }
    function close() { overlay.classList.remove("is-open"); syncScrollLock(); }

    if (openBtn) openBtn.addEventListener("click", open);
    var closeBtn = document.getElementById("search-close");
    if (closeBtn) closeBtn.addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

    var t;
    input.addEventListener("input", function () {
      var q = input.value.trim();
      clearTimeout(t);
      if (q.length < 2) { results.innerHTML = ""; return; }
      t = setTimeout(function () {
        /* JSON-Endpoint: liefert strukturierte Treffer, die wir markenkonform rendern.
           (Das Section-Rendering mit resources[...] beantwortet dieser Shop mit 422.) */
        fetch(ROUTES.predictiveSearch + ".json?q=" + encodeURIComponent(q) +
          "&resources[type]=product,page&resources[limit]=8")
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (input.value.trim() !== q) return; /* inzwischen weitergetippt */
            var res = (d.resources && d.resources.results) || {};
            results.innerHTML = renderSuggest(res, q);
          })
          .catch(function () { results.innerHTML = ""; });
      }, 220);
    });
  }

  /* ---------- Akkordeon ---------- */

  function initAccordions() {
    document.querySelectorAll(".acc-head").forEach(function (head) {
      head.addEventListener("click", function () {
        var item = head.parentElement;
        var body = item.querySelector(".acc-body");
        var isOpen = item.classList.contains("is-open");
        item.classList.toggle("is-open", !isOpen);
        body.style.maxHeight = isOpen ? "0" : body.scrollHeight + "px";
      });
    });
  }

  /* ---------- Filter-Chips ---------- */

  function initFilters() {
    var bar = document.querySelector("[data-filterbar]");
    if (!bar) return;
    bar.addEventListener("click", function (e) {
      var chip = e.target.closest(".chip");
      if (!chip) return;
      bar.querySelectorAll(".chip").forEach(function (c) { c.classList.remove("is-active"); });
      chip.classList.add("is-active");
      var f = chip.getAttribute("data-filter");
      document.querySelectorAll("[data-cat]").forEach(function (card) {
        var cats = (card.getAttribute("data-cat") || "").split(" ");
        card.style.display = (f === "alle" || cats.indexOf(f) !== -1) ? "" : "none";
      });
      applyFitVariants(bar, f.indexOf("fit-") === 0 ? f.slice(4) : null);
    });
  }

  /* "Passend für": Karten zeigen nach Grössenwahl Preis/Link/Schnell-Hinzufügen der passenden
     Variante (data-fit="60:id:preis,80:…" aus sections/azado-collection.liquid). */
  function applyFitVariants(bar, size) {
    var format = bar.getAttribute("data-money-format");
    var tmp = document.createElement("textarea");
    function fmt(cents) {
      var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      tmp.innerHTML = (format || "CHF {{amount}}").replace(/\{\{\s*\w+\s*\}\}/, n);
      return tmp.value.replace(/<[^>]*>/g, "");
    }
    document.querySelectorAll(".product-card[data-fit]").forEach(function (card) {
      var price = card.querySelector(".price");
      var quick = card.querySelector(".quick-add");
      if (!card.dataset.baseHref) {
        card.dataset.baseHref = card.getAttribute("href");
        if (price) card.dataset.basePrice = price.textContent;
        if (quick) card.dataset.baseVariant = quick.getAttribute("data-variant-id");
      }
      var hit = null;
      if (size) {
        card.getAttribute("data-fit").split(",").forEach(function (entry) {
          var parts = entry.split(":");
          if (parts[0] === size) hit = { id: parts[1], price: parseInt(parts[2], 10) };
        });
      }
      card.setAttribute("href", hit ? card.dataset.baseHref + "?variant=" + hit.id : card.dataset.baseHref);
      if (price) price.textContent = hit ? fmt(hit.price) : card.dataset.basePrice;
      if (quick) quick.setAttribute("data-variant-id", hit ? hit.id : card.dataset.baseVariant);
    });
  }

  /* ---------- Grill-Kategorie: Grösse + Kurbel-Filter (zwei Dimensionen, UND-verknüpft) ---------- */

  function initGrillFilters() {
    var sizeWrap = document.getElementById("filter-size");
    var kurbelWrap = document.getElementById("filter-kurbel");
    if (!sizeWrap || !kurbelWrap) return;

    var state = { size: "alle", kurbel: "alle" };

    function applyFilters() {
      document.querySelectorAll("[data-cat]").forEach(function (card) {
        var cats = (card.getAttribute("data-cat") || "").split(" ");
        var sizeOk = state.size === "alle" || cats.indexOf(state.size) !== -1;
        var kurbelOk = state.kurbel === "alle" || cats.indexOf(state.kurbel) !== -1;
        card.style.display = (sizeOk && kurbelOk) ? "" : "none";
      });
    }

    /* Bei 100cm ("gross") gibt es kein 2-Kurbel-Modell — Option ausblenden und bei Bedarf
       automatisch auf "Alle" zurücksetzen, statt eine leere Ergebnisliste zu zeigen. */
    function syncKurbelAvailability() {
      var twoKurbelItem = kurbelWrap.querySelector('[data-kurbel="2-kurbel"]');
      if (!twoKurbelItem) return;
      var unavailable = state.size === "gross";
      twoKurbelItem.hidden = unavailable;
      if (unavailable && state.kurbel === "2-kurbel") {
        var resetItem = kurbelWrap.querySelector('[data-kurbel="alle"]');
        if (resetItem) resetItem.click();
      }
    }

    function wireDropdown(wrap, stateKey) {
      var valueEl = wrap.querySelector(".filter-pill__value");
      var items = wrap.querySelectorAll(".filter-pill__item");
      var list = wrap.querySelector(".filter-pill__list");
      items.forEach(function (item) {
        item.addEventListener("click", function () {
          items.forEach(function (i) { i.classList.remove("is-active"); });
          item.classList.add("is-active");
          state[stateKey] = item.dataset[stateKey] || "alle";
          valueEl.textContent = item.textContent.trim();
          list.hidden = true;
          wrap.querySelector(".filter-pill__toggle").setAttribute("aria-expanded", "false");
          applyFilters();
          if (stateKey === "size") syncKurbelAvailability();
        });
      });
    }

    wireDropdown(sizeWrap, "size");
    wireDropdown(kurbelWrap, "kurbel");
    syncKurbelAvailability();
  }

  /* ---------- Grill-Selektor ---------- */

  function initSelector() {
    var root = document.getElementById("grill-selector");
    if (!root) return;
    var items = [].slice.call(root.querySelectorAll(".sel-item"));
    var imgs = [].slice.call(root.querySelectorAll(".sel-img"));
    var caption = root.querySelector(".sel-caption");
    function activate(key) {
      items.forEach(function (it) { it.classList.toggle("is-active", it.getAttribute("data-key") === key); });
      imgs.forEach(function (im) { im.classList.toggle("is-active", im.getAttribute("data-key") === key); });
      var active = items.filter(function (it) { return it.getAttribute("data-key") === key; })[0];
      if (active && caption) caption.textContent = active.getAttribute("data-caption") || "";
    }
    items.forEach(function (it) {
      var key = it.getAttribute("data-key");
      ["mouseenter", "click", "focus"].forEach(function (ev) {
        it.addEventListener(ev, function () { activate(key); });
      });
    });
  }

  /* ---------- Sticky CTA ---------- */

  function initNewsletterPopup() {
    var popup = document.getElementById("newsletter-popup");
    if (!popup) return;
    /* localStorage statt sessionStorage: einmal weggeklickt, soll das Popup diesem Besucher nie
       wieder angezeigt werden — nicht nur innerhalb derselben Browser-Session. */
    var SEEN_KEY = "azadoNewsletterSeen";
    var alreadySeen;
    try { alreadySeen = localStorage.getItem(SEEN_KEY); } catch (err) { alreadySeen = null; }
    if (alreadySeen) return;
    /* V2: nie beim Kaufen stören (Produkt, Warenkorb) und nie beim ersten Seitenaufruf —
       Luxusmarken verzichten auf Einstiegs-Popups (NNg/Baymard). Erst ab der zweiten Seite. */
    if (/\/(products|cart)(\/|$)/.test(location.pathname)) return;
    var views = 0;
    try { views = parseInt(sessionStorage.getItem("azadoViews") || "0", 10) + 1; sessionStorage.setItem("azadoViews", String(views)); } catch (err) { views = 2; }
    if (views < 2) return;

    function open() {
      if (document.querySelector(".floating-chat-popup.is-open, .az-concierge.is-open, .cart-drawer.is-open, .search-overlay.is-open")) return;
      popup.classList.add("is-open");
      popup.setAttribute("aria-hidden", "false");
      syncScrollLock();
    }
    function close() {
      popup.classList.remove("is-open");
      popup.setAttribute("aria-hidden", "true");
      syncScrollLock();
      try { localStorage.setItem(SEEN_KEY, "1"); } catch (err) {}
    }

    /* Exit-Intent (Desktop): Maus verlässt das Fenster oben Richtung Adressleiste/Tab schliessen —
       das ist der Moment, in dem ein Popup am wenigsten stört und am ehesten noch wirkt. 60s-Timer
       bleibt als Fallback für Mobile/Touch, wo es keine Maus zum Erkennen von Exit-Intent gibt. */
    var timer = setTimeout(open, 60000);
    function onMouseOut(e) {
      if (e.clientY > 0 || e.relatedTarget) return;
      clearTimeout(timer);
      document.removeEventListener("mouseout", onMouseOut);
      open();
    }
    document.addEventListener("mouseout", onMouseOut);

    popup.querySelectorAll("[data-popup-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
    var form = popup.querySelector("form");
    if (form) {
      form.addEventListener("submit", function () {
        try { localStorage.setItem(SEEN_KEY, "1"); } catch (err) {}
      });
    }
  }

  function initFloatingCta() {
    var cta = document.getElementById("floating-cta");
    if (!cta) return;
    function reveal() {
      if (window.scrollY > window.innerHeight * 0.5) {
        cta.classList.add("is-visible");
        window.removeEventListener("scroll", reveal);
      }
    }
    window.addEventListener("scroll", reveal, { passive: true });
    reveal();
  }

  function initFloatingChat() {
    var openBtn = document.getElementById("floating-chat-open");
    var popup = document.getElementById("floating-chat-popup");
    if (!openBtn || !popup) return;
    function open() {
      popup.classList.add("is-open");
      popup.setAttribute("aria-hidden", "false");
      var firstField = popup.querySelector("input, textarea");
      if (firstField) firstField.focus();
    }
    function close() {
      popup.classList.remove("is-open");
      popup.setAttribute("aria-hidden", "true");
      openBtn.focus();
    }
    openBtn.addEventListener("click", open);
    popup.querySelectorAll("[data-popup-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && popup.classList.contains("is-open")) close();
    });
    /* Formular erfolgreich abgeschickt (Seite lädt mit ?form_type=contact neu) → Popup gleich offen zeigen. */
    if (popup.querySelector(".az-contact-form__status")) open();
  }

  /* ---------- Film ---------- */

  function initFilm() {
    document.querySelectorAll("[data-film]").forEach(function (wrap) {
      var video = wrap.querySelector("video");
      var toggle = wrap.querySelector(".film-toggle");
      if (!video || !toggle) return;
      toggle.addEventListener("click", function () {
        if (video.paused) { video.play(); toggle.textContent = "❙❙"; }
        else { video.pause(); toggle.textContent = "▶"; }
      });
    });
  }

  /* ---------- Google-Bewertungen: Reihenfolge zufällig mischen ---------- */

  /* Der Marquee rendert jede Bewertung doppelt hintereinander (für den nahtlosen Loop) — beim
     Mischen wird dieselbe zufällige Reihenfolge auf beide Hälften angewendet, damit der Loop
     weiterhin nahtlos bleibt. Läuft bei jedem Seitenaufruf neu, zeigt also nicht immer dieselben
     Bewertungen zuerst. */
  function initReviewsShuffle() {
    document.querySelectorAll(".az-greviews__track").forEach(function (track) {
      var cards = Array.prototype.slice.call(track.children);
      var n = cards.length / 2;
      if (!Number.isInteger(n) || n < 2) return;
      var order = [];
      for (var i = 0; i < n; i++) order.push(i);
      for (var i = order.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = order[i]; order[i] = order[j]; order[j] = tmp;
      }
      var frag = document.createDocumentFragment();
      order.forEach(function (idx) { frag.appendChild(cards[idx]); });
      order.forEach(function (idx) { frag.appendChild(cards[n + idx]); });
      track.appendChild(frag);
    });
  }

  /* ---------- Lifestyle-Slideshow (Über-uns-Seite) ---------- */

  /* Goldener Cursor-Schimmer: auf jedem Element mit [data-gold-trail] + einem Kind
     ".az-goldtrail__glow" (siehe azado-core.css). Wiederverwendbar über mehrere Sections einer
     Seite hinweg (z.B. auf "Über uns": Manifest, Geschichte, Finde uns, Team). */
  function initGoldTrail() {
    document.querySelectorAll("[data-gold-trail]").forEach(function (root) {
      if (root.dataset.goldTrailBound) return;
      var glow = root.querySelector(".az-goldtrail__glow");
      if (!glow) return;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      root.dataset.goldTrailBound = "true";

      var tx = 50, ty = 50, cx = 50, cy = 50, raf = null;
      function loop() {
        cx += (tx - cx) * 0.08;
        cy += (ty - cy) * 0.08;
        glow.style.setProperty("--gx", cx + "%");
        glow.style.setProperty("--gy", cy + "%");
        if (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) {
          raf = requestAnimationFrame(loop);
        } else {
          raf = null;
        }
      }
      root.addEventListener("mousemove", function (e) {
        var rect = root.getBoundingClientRect();
        tx = ((e.clientX - rect.left) / rect.width) * 100;
        ty = ((e.clientY - rect.top) / rect.height) * 100;
        if (!raf) raf = requestAnimationFrame(loop);
      });
      root.addEventListener("mouseleave", function () {
        tx = 50; ty = 50;
        if (!raf) raf = requestAnimationFrame(loop);
      });
    });
  }

  function initSlideshow() {
    document.querySelectorAll(".az-slideshow").forEach(function (root) {
      if (root.dataset.slideshowBound) return;
      root.dataset.slideshowBound = "true";
      var slides = [].slice.call(root.querySelectorAll(".az-slideshow__slide"));
      var dots = [].slice.call(root.querySelectorAll(".az-slideshow__dot"));
      if (slides.length < 2) return;
      var interval = parseInt(root.dataset.interval, 10) || 5000;
      var current = 0;
      var timer = null;
      function show(i) {
        slides[current].classList.remove("is-active");
        if (dots[current]) dots[current].classList.remove("is-active");
        current = (i + slides.length) % slides.length;
        slides[current].classList.add("is-active");
        if (dots[current]) dots[current].classList.add("is-active");
      }
      function next() { show(current + 1); }
      function start() {
        if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        stop();
        timer = setInterval(next, interval);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      dots.forEach(function (dot, i) {
        dot.addEventListener("click", function () { show(i); start(); });
      });
      root.addEventListener("mouseenter", stop);
      root.addEventListener("mouseleave", start);
      start();
    });
  }

  /* ---------- Lazy-Load für nicht-kritische Autoplay-Videos ----------
     <video autoplay> lädt sonst sofort beim Seitenaufruf, egal ob die Section überhaupt
     im sichtbaren Bereich liegt — bei mehreren Videos pro Seite (Feature-Duo, Film) konkurrieren
     die dann alle gleichzeitig um Bandbreite. Stattdessen: kein autoplay-Attribut/preload=none
     im Markup, hier erst per IntersectionObserver laden+abspielen, kurz bevor sie sichtbar werden. */
  function initLazyVideos() {
    /* V2: Videos laden erst, wenn sie wirklich in die Nähe des Bildschirms kommen (300px statt
       1000px Vorlauf, kein "alle nach 2s starten" mehr: das lud auf der Startseite ca. 75 MB).
       data-src-mobile = kleinere Datei fürs Handy. Bei "Bewegung reduzieren"/Datensparmodus
       bleibt das Posterbild stehen. */
    var videos = [].slice.call(document.querySelectorAll("video.az-lazy-video"));
    if (!videos.length) return;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var conn = navigator.connection || {};
    var saveData = !!conn.saveData || /2g$/.test(conn.effectiveType || "");
    var small = window.matchMedia && window.matchMedia("(max-width: 768px)").matches;
    function start(video) {
      if (video.__azStarted) return;
      video.__azStarted = true;
      var mobileSrc = video.getAttribute("data-src-mobile");
      if (small && mobileSrc && video.getAttribute("src") !== mobileSrc) video.setAttribute("src", mobileSrc);
      if (reduce || saveData) return;
      video.preload = "auto";
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!("IntersectionObserver" in window)) { videos.forEach(start); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { start(entry.target); io.unobserve(entry.target); }
      });
    }, { rootMargin: "300px 0px", threshold: 0 });
    videos.forEach(function (video) { io.observe(video); });
  }

  /* ---------- Partikel + Easter Eggs ---------- */

  function spawnParticles(x, y, chars, count) {
    for (var i = 0; i < count; i++) {
      (function () {
        var p = document.createElement("div");
        p.className = "particle";
        p.textContent = chars[Math.floor(Math.random() * chars.length)];
        p.style.cssText = "left:" + x + "px;top:" + y + "px;font-size:" + (10 + Math.random() * 18) + "px;opacity:1;";
        document.body.appendChild(p);
        var ang = Math.random() * Math.PI * 2, v = 60 + Math.random() * 180;
        var vx = Math.cos(ang) * v, vy = Math.sin(ang) * v - 140;
        var life = 900 + Math.random() * 800, start = performance.now();
        (function tick(now) {
          var t = (now - start) / life;
          if (t >= 1) { p.remove(); return; }
          p.style.transform = "translate(" + vx * t + "px," + (vy * t + 320 * t * t) + "px) rotate(" + t * 360 + "deg)";
          p.style.opacity = String(1 - t);
          requestAnimationFrame(tick);
        })(start);
      })();
    }
  }
  window.azadoSparks = spawnParticles;

  function initEasterEggs() {
    var logo = document.getElementById("logo");
    if (logo) {
      var clicks = 0, timer;
      logo.addEventListener("click", function (e) {
        clicks++;
        clearTimeout(timer);
        timer = setTimeout(function () { clicks = 0; }, 1600);
        if (clicks >= 5) {
          clicks = 0; e.preventDefault();
          var r = logo.getBoundingClientRect();
          spawnParticles(r.left + r.width / 2, r.top + r.height / 2, ["🔥", "✦", "🥩"], 26);
          toast("Grillmeister-Modus. <em>Fünf Klicks, fünf Minuten, fertig ist die Glut.</em>");
        }
      });
    }
    var typed = "";
    document.addEventListener("keydown", function (e) {
      if (e.key.length !== 1) return;
      typed = (typed + e.key.toLowerCase()).slice(-6);
      if (typed.endsWith("asado") && !typed.endsWith("azado")) {
        toast("Fast richtig. Bei uns schreibt man das mit z: <em>azado</em>.");
      }
    });
    var egg = document.getElementById("flame-egg");
    if (egg) egg.addEventListener("click", function () {
      var r = egg.getBoundingClientRect();
      spawnParticles(r.left, r.top, ["🔥"], 18);
      toast("Wer zündelt, dem wird geholfen. <em>Glut in 5 Minuten gibt es oben.</em>");
    });
    document.querySelectorAll(".if-badge").forEach(function (b) {
      b.addEventListener("click", function () {
        var r = b.getBoundingClientRect();
        spawnParticles(r.left + r.width / 2, r.top + r.height / 2, ["✦", "✧", "★"], 30);
        toast("iF Design Award 2026 für den <em>El Jefesito</em>. Wir sind selbst noch ein bisschen stolz.");
      });
    });
  }

  /* ---------- 5-Minuten-Zünd-Timer ---------- */

  function initTimer() {
    var root = document.getElementById("timer");
    if (!root) return;
    var timeEl = root.querySelector(".timer-time");
    var labelEl = root.querySelector(".timer-label");
    var ring = root.querySelector(".ring-fg");
    var startBtn = root.querySelector("#timer-start");
    var speedBtn = root.querySelector("#timer-speed");
    var coals = root.querySelectorAll(".coal");
    var steps = [].slice.call(document.querySelectorAll(".timer-step"));
    if (!timeEl || !ring || !startBtn) return;

    var R = 158, CIRC = 2 * Math.PI * R;
    ring.style.strokeDasharray = CIRC;
    ring.style.strokeDashoffset = CIRC;

    var DURATION = 300, FAST_SCALE = 30, timeScale = FAST_SCALE, state = "idle", elapsed = 0, lastTs = null;
    var readyLabel = root.dataset.readyLabel || "Bereit? Dreh das Gas auf.";
    var startLabel = root.dataset.startLabel || "Jetzt anfeuern";
    var runningLabel = root.dataset.runningLabel || "Es glüht…";
    var doneLabel = root.dataset.doneLabel || "Nochmal anfeuern";
    var speedFastLabel = root.dataset.speedFastLabel || "Zeitraffer an";
    var speedRealLabel = root.dataset.speedRealLabel || "Echtzeit an";
    var PHASES;
    try {
      PHASES = JSON.parse(root.dataset.phases);
      if (!PHASES || !PHASES.length) throw new Error("empty");
    } catch (e) {
      PHASES = [
        { at: 0, label: "Gas läuft. Lehn dich zurück." },
        { at: 60, label: "Die Flamme arbeitet für dich." },
        { at: 150, label: "Erste Glutnester glimmen." },
        { at: 250, label: "Gleich ist es so weit." },
        { at: 300, label: "Glut bereit. Gas aus, Rost drauf." }
      ];
    }

    function heatColor(h) {
      var stops = [[42,42,39],[72,34,24],[178,62,30],[255,122,40],[255,200,90]];
      var pos = h * (stops.length - 1);
      var i = Math.min(Math.floor(pos), stops.length - 2), f = pos - i;
      return "rgb(" + stops[i].map(function (v, k) {
        return Math.round(v + (stops[i + 1][k] - v) * f);
      }).join(",") + ")";
    }

    function render() {
      var t = Math.min(elapsed, DURATION);
      timeEl.textContent = Math.floor(t / 60) + ":" + (Math.floor(t % 60) < 10 ? "0" : "") + Math.floor(t % 60);
      ring.style.strokeDashoffset = CIRC * (1 - t / DURATION);
      var phase = PHASES[0];
      PHASES.forEach(function (p) { if (t >= p.at) phase = p; });
      if (labelEl) labelEl.textContent = state === "idle" ? readyLabel : phase.label;
      steps.forEach(function (st, i) {
        var at = parseFloat(st.getAttribute("data-at"));
        var next = steps[i + 1] ? parseFloat(steps[i + 1].getAttribute("data-at")) : Infinity;
        st.classList.toggle("is-done", t > at && state !== "idle");
        st.classList.toggle("is-active", state !== "idle" && t >= at && t < next);
      });
      var progress = t / DURATION;
      coals.forEach(function (c, i) {
        var h = Math.max(0, Math.min(1, (progress - (i * 0.55) / coals.length) / 0.5));
        c.style.background = heatColor(h);
        c.style.boxShadow = h > 0.25 ? "0 0 " + h * 26 + "px rgba(255,140,50," + h * 0.85 + ")" : "none";
      });
      if (progress >= 0.5) ring.style.stroke = "#FF9A8D";
      if (progress >= 0.9) ring.style.stroke = "#FFE699";
    }

    function loop(ts) {
      if (state !== "running") return;
      if (lastTs === null) lastTs = ts;
      elapsed += ((ts - lastTs) / 1000) * timeScale;
      lastTs = ts;
      if (elapsed >= DURATION) {
        elapsed = DURATION; state = "done"; render();
        startBtn.innerHTML = doneLabel;
        var r = timeEl.getBoundingClientRect();
        spawnParticles(r.left + r.width / 2, r.top, ["🔥", "✦"], 24);
        toast("<em>5:00</em> und die Glut ist bereit. Genau so funktioniert jeder azado mit Gaselement.");
        return;
      }
      render();
      requestAnimationFrame(loop);
    }

    function start() {
      if (state === "running") return;
      elapsed = 0; lastTs = null; ring.style.stroke = "#B2A185";
      state = "running"; startBtn.innerHTML = runningLabel;
      requestAnimationFrame(loop);
    }

    startBtn.addEventListener("click", start);

    if (speedBtn) speedBtn.addEventListener("click", function () {
      if (timeScale === FAST_SCALE) { timeScale = 1; speedBtn.textContent = speedRealLabel; toast("Echtzeit. Genau 5 Minuten."); }
      else { timeScale = FAST_SCALE; speedBtn.textContent = speedFastLabel; }
    });

    render();

    /* Startet automatisch, aber erst wenn der Timer beim Scrollen sichtbar wird — nicht schon
       beim Laden der Seite, während er noch weit ausserhalb des Viewports steht. */
    if ("IntersectionObserver" in window) {
      var timerIo = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { timerIo.unobserve(root); start(); }
      }, { threshold: 0.4 });
      timerIo.observe(root);
    } else {
      start();
    }
  }

  /* ---------- Hell/Dunkel-Umschalter ----------
     Dunkel ist Marke und Standard. Die Wahl liegt in localStorage "azadoTheme"; das Inline-Script
     ganz oben in layout/theme.liquid setzt data-theme schon vor dem ersten Paint (kein Aufblitzen). */
  function initThemeToggle() {
    var root = document.documentElement;
    var buttons = document.querySelectorAll("[data-theme-toggle]");
    function sync() {
      var light = root.getAttribute("data-theme") === "light";
      buttons.forEach(function (btn) {
        var label = light ? btn.dataset.labelDark : btn.dataset.labelLight;
        btn.setAttribute("aria-pressed", light ? "true" : "false");
        btn.setAttribute("aria-label", label);
        if (btn.classList.contains("nmp-theme")) btn.textContent = label;
      });
      var meta = document.querySelector('meta[name="theme-color"]');
      if (meta) meta.setAttribute("content", light ? "#F6F3EE" : "#121110");
    }
    buttons.forEach(function (btn) {
      if (btn.dataset.themeBound) return;
      btn.dataset.themeBound = "true";
      btn.addEventListener("click", function () {
        var next = root.getAttribute("data-theme") === "light" ? "dark" : "light";
        root.setAttribute("data-theme", next);
        try { localStorage.setItem("azadoTheme", next); } catch (e) {}
        sync();
      });
    });
    sync();
  }

  /* ---------- Boot ---------- */

  function boot() {
    document.body.classList.add("is-ready");
    /* Jede Funktion einzeln absichern: ein Fehler in einem Baustein darf nicht alle folgenden
       stoppen (sonst bleiben z. B. alle [data-reveal]-Bereiche unsichtbar). */
    [
      initThemeToggle, initHeaderScroll, initHeroVideoToggle, initNavMore, initLangSelect,
      initSortSelect, initReveals, initParallax, initOverlapScroll, initCart, initUpsell,
      initSearch, initAccordions, initFilters, initFilterPills, initGrillFilters, initSelector,
      initFloatingCta, initFloatingChat, initNewsletterPopup, initReviewsShuffle, initFilm,
      initSlideshow, initGoldTrail, initLazyVideos, initTimer, initEasterEggs
    ].forEach(function (fn) {
      try { fn(); } catch (err) { if (window.console) console.error("azado " + fn.name + ":", err); }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }

  /* Shopify Theme-Editor: Sections neu laden */
  document.addEventListener("shopify:section:load", function () { boot(); });
})();
